module.exports = __webpack_public_path__ + "img/bar-chart-dark.e05bc9d3.svg";